import { HeroSection } from '../components/HeroSection';
import { ServicesSection } from '../components/ServicesSection';

export default function Home() {
  return (
    <main data-testid="home-page">
      <HeroSection />
      <ServicesSection />
      <div className="py-8 text-center border-t border-slate-50 bg-white">
        <p className="text-[10px] md:text-xs text-slate-400 tracking-wider font-medium">
          MADE BY <span className="text-slate-900 font-bold">APEXNUERA TECHNOLOGIES</span>
        </p>
      </div>
    </main>
  );
}
